"use client"

import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok } from "react-icons/fa"
import { FaX } from "react-icons/fa6"

export default function Footer() {
  return (
    <footer
      className="text-white pt-5 pb-4 position-relative"
      style={{
        background: "linear-gradient(135deg, #000000ff 0%, #1b41aaff 50%, #103c71ff 100%)",
        overflow: "hidden",
        boxShadow: "0 -10px 40px rgba(0,0,0,0.3)",
      }}
    >
      <div className="container position-relative">
        <div className="row">

          {/* ================= BRAND ================= */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-3" style={{ fontSize: "1.5rem" }}>
              u2lr Link Shortener
            </h5>

            <p style={{ color: "rgba(255,255,255,0.7)", lineHeight: "1.6" }}>
              Smart links, dynamic QR codes, and powerful analytics — all in one platform.
            </p>

            <div className="d-flex gap-3 mt-4">
              {[
                { Icon: FaFacebookF, url: "https://www.facebook.com/profile.php?id=61587010800185" },
                { Icon: FaX, url: "https://x.com/u2lrlinks" },
                { Icon: FaTiktok, url: "https://www.tiktok.com/@u2lrshortener" },
                { Icon: FaInstagram, url: "https://www.instagram.com/u2lrlinks" },
                { Icon: FaLinkedinIn, url: "https://www.linkedin.com/in/u2lrlink-shortener-008b943a7" },
              ].map(({ Icon, url }, idx) => (
                <a
                  key={idx}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon d-flex align-items-center justify-content-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                  }}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          {/* ================= PRODUCTS ================= */}
          <div className="col-md-2 mb-4">
            <h6 className="footer-heading">Products</h6>
            <ul className="list-unstyled">
              {[
                { to: "/our-products/url-shortener", label: "URL Shortener" },
                { to: "/our-products/qr-codes", label: "Dynamic QR Codes" },
                { to: "/our-products/analytics", label: "Analytics" },
                { to: "/u2lr-pricing", label: "Pricing" },
              ].map((link, idx) => (
                <li key={idx} className="mb-2">
                  <a href={link.to} className="footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ================= COMPANY ================= */}
          <div className="col-md-2 mb-4">
            <h6 className="footer-heading">Company</h6>
            <ul className="list-unstyled">
              {[
                { to: "/", label: "Home" },
                { to: "/about-us", label: "About Us" },
                { to: "/blog/all-article", label: "Blogs" },
                { to: "/contact-us", label: "Contact" },
              ].map((link, idx) => (
                <li key={idx} className="mb-2">
                  <a href={link.to} className="footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ================= LEGAL ================= */}
          <div className="col-md-2 mb-4">
            <h6 className="footer-heading">Legal</h6>
            <ul className="list-unstyled">
              {[
                { to: "/privacy-policy", label: "Privacy Policy" },
                { to: "/refund-policy", label: "Refund Policy" },
                { to: "/terms-of-service", label: "Terms of Service" },
              ].map((link, idx) => (
                <li key={idx} className="mb-2">
                  <a href={link.to} className="footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ================= NEWSLETTER ================= */}
          <div className="col-md-3 mb-4">
            <h6 className="footer-heading">Stay Updated</h6>

            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.9rem" }}>
              Product updates, new features, and offers.
            </p>

            <form className="d-flex gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                required
                className="form-control-footer"
              />
              <button type="submit" className="btn btn-primary btn-sm">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <hr style={{ borderColor: "rgba(255,255,255,0.1)" }} />

        <div className="text-center">
          <small style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "0.875rem" }}>
            &copy; 2020 - {new Date().getFullYear()} u2lr Link Shortener · All rights reserved. | <i>Developed: by TegaFate HuB</i>
          </small> 
        </div>
      </div>

      <style>{`
        .footer-heading {
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 1rem;
          color: rgba(255,255,255,0.5);
        }

        .footer-link {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          font-size: 0.95rem;
          transition: all 0.3s ease;
        }

        .footer-link:hover {
          color: #ffffff;
          transform: translateX(4px);
        }

        .form-control-footer {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          color: white;
          border-radius: 8px;
          padding: 0.5rem 0.75rem;
        }

        .form-control-footer::placeholder {
          color: rgba(255,255,255,0.4);
        }
      `}</style>
    </footer>
  )
}
